import { useContext } from 'react';

import type { PromoteFormData } from './context';
import { PromoteFormDataContext } from './context';

export function usePromoteFormData(): PromoteFormData {
	const context = useContext(PromoteFormDataContext);
	if (!context) {
		throw new Error('usePromoteFormData must be used within a PromoteFormDataProvider');
	}
	return context;
}
